<template>
	<div class="platformmerchantindex">
		<div class="top">
			<el-button size="medium" type="primary" @click="platformmerchantadd()">新增平台商户</el-button>
		</div>
		<div>
			<el-table :height="windowHeight - 210" :data="dataList" style="width: 100%" border>			
				<el-table-column label="平台商户名称" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span class="link" @click="merchantstatistics(scope.row.merId)">{{ scope.row.merName }}</span>
					</template>
				</el-table-column>
				<el-table-column label="平台商户编码" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.merId }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="学校名称" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.schoolName }}
						</span>
					</template>
				</el-table-column>
                <!-- <el-table-column label="证书名称" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.passwd }}
						</span>
					</template>
				</el-table-column> -->
                <el-table-column label="创建时间" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.createTime }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<!-- <el-button type="text" size="small" @click="deleteAbcagent(scope.row.id)">删除</el-button> -->
						<el-button type="text" size="small"  @click="platformmerchantlist(scope.row.merId)">清分记录</el-button>
						<el-button type="text" size="small"  @click="cashoutreconciliation(scope.row.merId)">出金对账</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-container">
				<el-pagination @size-change="sizeChangeHandler" @current-change="currentChangeHandler" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size.sync="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :page-count="pagination.pages" :total="pagination.total"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>

import windowResize from '@/mixins/windowResize'
import baseMixin from '@/mixins/baseMixin'
import {queryAbcagentList,deleteAbcagent} from '@/api/platformmerchant'

export default {
	name: 'subjectList',
	data() {
		return {
			pagination: {
				pageNo: 1,
				pageSize: 10,
				total: 0
			},
			dataList: [],
		}
	},
	created() {
		this.queryAbcagentList()
	},
	mixins: [windowResize, baseMixin],
	methods: {	
        platformmerchantadd(){
           this.$router.push({path:'platformmerchantadd'});
        },
		platformmerchantlist(merId){
           this.$router.push({path:'platformmerchantlist',query:{
			   merId:merId
		   }});
        },
		cashoutreconciliation(merId){
           this.$router.push({path:'cashoutreconciliation',query:{
			   merId:merId
		   }});
        },
		merchantstatistics(merId){
           this.$router.push({path:'merchantstatistics',query:{
			   merId:merId
		   }});
        },
		deleteAbcagent(id) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteAbcagent(id).then(res => {
						this.queryAbcagentList()
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		sizeChangeHandler() {
			this.queryAbcagentList()
		},
		currentChangeHandler() {
			this.queryAbcagentList()
		},
		queryAbcagentList() {
		 queryAbcagentList(this.pagination)
        .then(res => res.data)
        .then(data => {
          this.pagination.total = data.data.pagination.total;
          this.dataList = data.data.dataList;
        });
		}
	}
}
</script>
<style lang="scss" scoped>
.platformmerchantindex {
	padding: 12px;
	.pagination-container {
		margin-top: 10px;
	}
	.top {
		padding-bottom: 10px;
		overflow: hidden;
	}
	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}
	.state-container {
		margin: 15px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/platformmerchant/platformmerchantindex.vue